export default __webpack_public_path__ + "static/media/velas.e8f0bd4d.svg";